module.exports = __webpack_public_path__ + "img/zimg6.ea041bf8.png";